import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

import Close from "@material-ui/icons/Close";
import Info from "@material-ui/icons/Info";
// core components
import GridContainer from "components/Grid/GridContainer.js";

import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput.js";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import SweetAlert from "react-bootstrap-sweetalert";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import Loading from "components/loading.js";
import { addStudies, getPubmedDetails as fetchPubmedDetails } from "services/projectsApi";
import { updateUser } from "services/adminApi";

const stylesCard = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
};

const stylesList = {
  list: {
    display: "inline",
    padding: "5px",
  },
};

const alertOverrides = {
  marginTop: "-100px",
  marginRight: "0px",
  marginBottom: "0px",
  marginLeft: "0px",
};
const useStylesAlert = makeStyles(stylesAlert);

const useStylesModal = makeStyles(stylesModal);

const useStylesCard = makeStyles(stylesCard);

const useStylesList = makeStyles(stylesList);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function Studies(props) {
  const classesAlert = useStylesAlert();
  const classesModal = useStylesModal();
  const classesCard = useStylesCard();
  const classesList = useStylesList();

  const classes = {
    ...classesAlert,
    ...classesModal,
    ...classesCard,
    ...classesList,
  };

  const [title, setTitle] = React.useState("");

  const [uid, setUid] = React.useState("");
  const [authors, setAuthors] = React.useState("");
  const [date, setDate] = React.useState("");

  const [pmid, setPmid] = React.useState("");
  //const [pmidState, setPmidState] = React.useState("");
  const [pmids, setPmids] = React.useState([]);
  const [pmidState, setPmidState] = React.useState("");

  const [pubs, setPubs] = React.useState([]);

  //const [pmidState, setPmidState] = React.useState("");
  const [urls, setUrls] = React.useState([]);

  const [alert, setAlert] = React.useState(null);

  const [addStudyModal, setAddStudyModal] = React.useState(false);

  const [infoModal, setInfoModal] = React.useState(false);

  const [loading, setLoading] = React.useState(false);

  const verifyPmid = (num) => {
    const numRex = /^[0-9]+$/;

    const numDigits = num.toString().length;
    if (
      numRex.test(num) &&
      numDigits >= 1 &&
      numDigits <= 8 &&
      !pmids.includes(num)
    ) {
      return true;
    }

    return false;
  };

  const { userInfo } = props;

  const access = userInfo.access;

  //const lastName =
  // props.userInfo.name && props.userInfo.name.split(/(\s+)/).slice(-1)[0];

  const studiesData = props.studies.filter(function (study) {
    // Filter out new pubmed IDs that were not already obtained in the database
    // return new RegExp("\\b" + lastName + "\\b").test(
    //   study.authors.toString()
    // );

    return (
      props.userInfo.verified_pubs &&
      props.userInfo.verified_pubs.includes(study.uid)
    );
  });

  const studyData = studiesData.map((prop) => {
    return {
      id: prop.id,
      title: prop.title,
      description: prop.description,
      uid: prop.uid,
      authors: prop.authors,
      date: prop.date,

      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to add a like kind of action */}
          {/* use this button to add a edit kind of action */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findTitleIndex = ({ title }) => {
                return title == prop.title;
              };

              const titleIndex = props.studies.findIndex(findTitleIndex);

              const studyData = props.studies[titleIndex];

              addData(studyData);
              setInfoModal(true);
            }}
            color="info"
            className="remove"
          >
            <Info />
          </Button>
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findTitleIndex = ({ title }) => {
                return title == prop.title;
              };

              const titleIndex = props.studies.findIndex(findTitleIndex);

              const studyData = props.studies[titleIndex];

              addData(studyData);

              confirmDeleteStudy(prop.uid, prop.title);
            }}
            color="danger"
            className="remove"
          >
            <Close />
          </Button>
        </div>
      ),
    };
  });

  const hideAlert = () => {
    setAlert(null);
  };

  const confirmDeleteStudy = (uid, title) => {
    setAlert(
      <SweetAlert
        warning
        style={alertOverrides}
        title="Are you sure?"
        onConfirm={() => handleDeleteStudy(uid)}
        onCancel={() => cancelDeleteStudy(title)}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      >
        {title} will be deleted!
      </SweetAlert>
    );
  };

  const cancelDeleteStudy = (title) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {title} Not Deleted!
      </SweetAlert>
    );
  };

  const successAddStudy = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => {
          hideAlert();
          setAddStudyModal(false);
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Study Added!
      </SweetAlert>
    );
  };

  const failAddStudy = (errorMessage) => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={errorMessage ? errorMessage : "Something Went Wrong!"}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        Study not added!
      </SweetAlert>
    );
  };

  const successDeleteStudy = () => {
    setAlert(
      <SweetAlert
        success
        style={alertOverrides}
        title="Success!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        {title} Deleted!
      </SweetAlert>
    );
  };

  const failDeleteStudy = () => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title="Something Went Wrong!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        {title} not Deleted!
      </SweetAlert>
    );
  };

  const confirmPub = (pub, pmid, pmids) => {
    setAlert(
      <SweetAlert
        warning
        style={alertOverrides}
        title={`Add ${pub.title} ?`}
        onConfirm={() => {
          handleAddElement(pmid, pmids, pub);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        confirmBtnText="Add Publication"
        cancelBtnText="Cancel"
        showCancel
      >
        Add Publication
      </SweetAlert>
    );
  };

  const failAddPub = () => {
    setAlert(
      <SweetAlert
        danger
        style={alertOverrides}
        title={"Unable to find publication. Please check Pubmed ID."}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.danger}
      >
        Publication not added!
      </SweetAlert>
    );
  };

  const handleSubmitAddStudy = async (e) => {
    e.preventDefault();

    const addPubs = await addStudies(pubs);

    /////NEED to change update profile route to see if study exists and if not create a new study.

    const {
      id,
      email,
      name,
      institution,
      about,
      type,
      verified_pubs,
      exclude_pubs,
    } = props.userInfo;

    const oldAndNewPubs =
      verified_pubs && verified_pubs.length > 0 ? [...verified_pubs] : [];

    const excludePubs =
      verified_pubs && verified_pubs.length > 0 ? [...exclude_pubs] : [];

    pmids.map((pub) => {
      oldAndNewPubs.push(pub);
    });

    const postValues = {
      email: email,
      name: name,
      institution: institution,
      about: about,
      type: type,
      verified_pubs: oldAndNewPubs,
      exclude_pubs: excludePubs,
    };
    const updateProfile = await updateUser(id, postValues);
    if (updateProfile.status == 200 && addPubs.status == 200) {
      successAddStudy();
      getStudies();
      getImagesUsers();
    } else {
      failAddStudy();
    }
  };

  async function getStudies() {
    props.reloadStudiesCallBack(true);
  }

  async function getImagesUsers() {
    props.reloadImagesUsersCallBack(true);
  }

  const handleDeleteStudy = async (uid) => {
    const {
      id,
      email,
      name,
      institution,
      about,
      type,
      verified_pubs,
      exclude_pubs,
    } = props.userInfo;

    console.log("OLD PUBS");
    console.log(verified_pubs);

    const filteredPubs = verified_pubs.filter((pub) => {
      return pub != uid;
    });

    console.log("NEW PUBS");
    console.log(filteredPubs);

    const postValues = {
      email: email,
      name: name,
      institution: institution,
      about: about,
      type: type,
      verified_pubs: filteredPubs,
      exclude_pubs: exclude_pubs,
    };

    const updateProfile = await updateUser(id, postValues);
    if (updateProfile.status == 200) {
      successDeleteStudy();
      getStudies();
      getImagesUsers();
    } else {
      failDeleteStudy();
    }
  };

  const addData = (studyData) => {
    studyData.title && setTitle(studyData.title);

    studyData.uid && setUid(studyData.uid);
    studyData.authors && setAuthors(String(studyData.authors));
    studyData.date && setDate(studyData.date);
  };

  const clearData = () => {
    setTitle("");
    setUid("");
    setAuthors("");
    setDate("");

    setPmid("");
    setPmids([]);

    setUrls([]);
    setPubs([]);
  };

  const handleAddElement = (element, elementList, pub) => {
    const elementListNew = elementList.filter(
      (element) => typeof element !== "undefined"
    );

    element != "" && elementListNew.push(element);

    if (elementList == pmids) {
      setPmids(elementListNew);
      setPmid("");
    }

    if (elementList == urls) {
      setUrls(elementListNew);
    }

    if (pub) {
      setPubs((currentPubs) => [...currentPubs, pub]);
    }
  };

  const handleRemoveElement = (element, elementList, pub) => {
    const elementListFiltered = elementList.filter((e) => e !== element);

    if (pub) {
      const pubsFiltered = pubs.filter((pubItem) => {
        return pubItem.uid != element;
      });

      setPubs(pubsFiltered);
    }

    if (elementList == pmids) {
      setPmids(elementListFiltered);
      setPmid("");
    }
    if (elementList == urls) {
      setUrls(elementListFiltered);
    }
  };

  const getPubmedDetails = async (pmid, pmids) => {
    setLoading(true);
    const details = await fetchPubmedDetails(pmid);
    setLoading(false);

    if (
      details.data &&
      details.data.info &&
      Object.keys(details.data.info).length > 1
    ) {
      confirmPub(details.data.info, pmid, pmids);
      return details.data.info;
    }
    console.log("Error");

    failAddPub();
    return "Error";
  };

  const dateObject = new Date(date);

  //const day = ("0" + date.getDate()).slice(-2);
  const month = ("0" + (dateObject.getMonth() + 1)).slice(-2);
  const year = dateObject.getFullYear();

  const dateFormatted = month + "/" + year;

  const link = "https://pubmed.ncbi.nlm.nih.gov/" + uid;

  return (
    <div>
      {alert}

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={addStudyModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setAddStudyModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => {
              clearData();
              setAddStudyModal(false);
            }}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>Add Study</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={handleSubmitAddStudy}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        success={pmidState === "success"}
                        error={pmidState === "error"}
                        labelText="Pubmed ID"
                        id="pmid"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: pmid,
                          onChange: (event) => {
                            if (verifyPmid(event.target.value)) {
                              setPmidState("success");
                            } else {
                              setPmidState("error");
                            }
                            setPmid(event.target.value);
                          },
                          type: "number",
                        }}
                      />
                      {loading && <Loading />}
                      <Button
                        color="info"
                        className={classes.updateProfileButton}
                        onClick={() => {
                          getPubmedDetails(pmid, pmids);
                        }}
                        disabled={
                          pmid.length > 0 && pmidState == "success"
                            ? false
                            : true
                        }
                      >
                        Add Pubmed ID
                      </Button>
                      <br />
                      {pmids &&
                        pmids.map((pmid) => (
                          <li className={classes.list} key={pmid}>
                            {pmid}
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                handleRemoveElement(pmid, pmids, true);
                              }}
                              color="danger"
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </li>
                        ))}
                    </GridItem>
                  </GridContainer>
                  <br></br>

                  <Button
                    color="info"
                    className={classes.updateProfileButton}
                    type="submit"
                    disabled={!(pmids.length > 0)}
                  >
                    Submit
                  </Button>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => {
              setAddStudyModal(false);
            }}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={infoModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setInfoModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setInfoModal(false)}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{title}</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            <GridContainer>
              {uid && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Pubmed ID</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <p>{uid}</p>
                  </GridItem>
                </GridContainer>
              )}
              {dateFormatted && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Date</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <p>{dateFormatted}</p>
                  </GridItem>
                </GridContainer>
              )}
              {authors && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Authors</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <p>{authors}</p>
                  </GridItem>
                </GridContainer>
              )}
              {link && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Abstract</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <a href={link} target="_blank" rel="noopener noreferrer">
                      {link}
                    </a>
                  </GridItem>
                </GridContainer>
              )}
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button onClick={() => setInfoModal(false)} color="rose" round>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              {access >= 4 && (
                <Button
                  color="info"
                  className={classes.updateProfileButton}
                  onClick={() => {
                    clearData();
                    setAddStudyModal(true);
                  }}
                >
                  Add Study
                </Button>
              )}

              <ReactTable
                columns={[
                  {
                    Header: "Title",
                    accessor: "title",
                  },
                  {
                    Header: "Pubmed ID",
                    accessor: "uid",
                  },

                  {
                    Header: "Actions",
                    accessor: "actions",
                  },
                ]}
                data={studyData}
                defaultPageSize={20}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

Studies.propTypes = {
  studies: PropTypes.array,
  users: PropTypes.array,
  userInfo: PropTypes.object,
  reloadStudiesCallBack: PropTypes.func,
  reloadImagesUsersCallBack: PropTypes.func,
};


